import script from "./WithColorMixin.vue?vue&type=script&lang=ts"
export * from "./WithColorMixin.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__